import './App.css';

function App() {
  return (
    <div className="App">
      <header className="hero-section">
        <h1>Pack Transform</h1>
        <p className="tagline">Your Trusted Partner in Packaging Solutions</p>
      </header>

      <section className="intro-section">
        <p>At Pack Transform, we pride ourselves on being a cutting-edge advisory firm in the packaging industry. Our approach is tailored to meet the evolving needs of our clients, ranging from raw material suppliers to brand owners, ensuring a comprehensive understanding of the entire packaging value chain.</p>
      </section>

      <section className="reach-us-section">
        <h2>CONTACT US</h2>
        <div className="contact-info">
          <p className="phone">+1-832-312-5501</p>
          <p className="email">support@packtransform.com</p>
          <p className="address">7106 Marble Springs Dr<br />Katy, TX 77494</p>
        </div>
      </section>

      <footer className="footer">
        <p>© 2025 TAP Global. All rights reserved. | Technology Partner - <a href="https://fritado.com" target="_blank" rel="noopener noreferrer">Fritado AI</a></p>
      </footer>
    </div>
  );
}

export default App;
